var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.654,
    height: 25.68,
    viewBox: "0 0 23.654 25.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.654,
    height: 25.68,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wiederholungsraster_1",
    "data-name": "Wiederholungsraster 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48.929 -284.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5543",
    "data-name": "Pfad 5543",
    d: "M26.183,30.18a1.987,1.987,0,0,0,1.971-2.14c0-2.14-1.971-8.56-11.827-8.56S4.5,25.9,4.5,28.04a1.987,1.987,0,0,0,1.971,2.14Zm-19.7-2.02v0Zm.033-.12H26.139l.028,0,.016,0a5.937,5.937,0,0,0-1.64-3.561c-1.285-1.394-3.7-2.85-8.216-2.85S9.4,23.075,8.111,24.47a5.954,5.954,0,0,0-1.64,3.561Zm19.661.12v0ZM16.327,15.2a4.122,4.122,0,0,0,3.942-4.28,4.122,4.122,0,0,0-3.942-4.28,4.122,4.122,0,0,0-3.942,4.28A4.122,4.122,0,0,0,16.327,15.2Zm5.914-4.28a6.182,6.182,0,0,1-5.914,6.42,6.182,6.182,0,0,1-5.914-6.42A6.182,6.182,0,0,1,16.327,4.5a6.182,6.182,0,0,1,5.914,6.42Z",
    transform: "translate(44.429 279.688)",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.fdb611917eeabe2c247a13853d331701.svg";
export { ForwardRef as ReactComponent };